export default {
  common: {
    days: 'days',
    months: 'months',
    required: 'required',
    myScope: 'My Scope',
    myIssue: 'My Reports',
    other: 'Other',
    save: 'Save',
    pending: 'In process',
    waiting: 'Pending',
    placeLoading: 'Addresses loading',
    auditLoading: 'Audit loading',
    auditReloading: 'Audit reloading',
    placeLoadingCaption: 'You can already work while you wait',
    placeLoaded: 'Addresses loading done',
    placeloadingError: 'Erreur while loading addresses',
    placeloadingErrorCaption: 'We will try again later',
    placeAbsent: 'Address not found',
    historyLoading: 'Loading in progress ...',
    historyLoadingPercentage: 'Loading in progress: {percentage}%',
    suggestions: 'Suggestions',
    allMonths: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    search: 'Search',
    error: {
      NoNetwork:
        'Impossible to join the server, please check your internet access',
      unmanagedError: 'An unmanaged error occured',
      unproceseableError: 'An error occured while saving',
      SessionExpired: 'Your session expired, please reconnect',
      unknownError: 'An error occured',
      unknownErrorLastAction: "An error occured while performing the last action",
      completeAllInformation: 'Please fill out the fields marked in red',
      serverError: 'Connection to the server failed',
      ResetError:
        'An error has occurred, please log in again by checking the reset box. If the problem persists, please contact your manager',
      suppressErrors: '{message} on: {idIssues}',
      throwJsonApiErrors: '{message} details \r\n {idIssues}'
    },
    true: 'Yes',
    false: 'No',
    user: 'User',
    done: 'Done',
    late: 'Late',
    details: 'Details',
    close: 'close',
    searchWarning: 'The search requires a minimum of 3 characters',
    searchError: 'No report matches your search',
    send: 'Send',
    audit: 'Audit',
    issue: 'Issue',
    cancel: 'Cancel',
    pageNotFound: 'page not found',
    noControlPending: 'No Control pending',
    thisWeek: 'this week',
    loading: 'loading',
    addRecipient: 'Add a recipient',
    status: 'Status',
    complaintNumber: 'Claim number',
    messaging: 'Messaging',
    waitPlease: 'Please wait.',
    downloading: 'Downloading',
    agency: 'Agency',
    sendAlert: 'Send alert',
    emailAddress: 'Email address',
    sendInfoToDev: 'Debugging information will be sent to the technical team.',
    sendInfoToTeam:
      'Additional information you would like to provide to the team regarding the problem you encountered (Optional):',
    helper: {
      statusTranslation: {
        pending: 'Pending',
        ongoing: 'Ongoing',
        done: 'Done',
        rejected: 'Rejected'
      },
      statusTaskTranslation: {
        pending: 'Sending pending',
        ongoing: 'Sending in progress',
        failed: 'Sending rejected'
      },
      translatePush: {
        UserConnected: {
          message: 'Welcome :',
          detail: 'You are now connected to SoWell'
        },
        IssueCreated: {
          message: 'New request :',
          detail: 'The request #{id} has just been created'
        },
        IssueUpdated: {
          message: 'Updated :',
          detail: 'The request #{id} has just been created'
        },
        IssueTalkCreated: {
          message: 'New message :',
          detail: 'A new message has just been recorded on request #{id}'
        },
        default: {
          message: 'Notification :'
        }
      }
    },
    hasPendingTaskDialog: {
      title: 'Logout',
      message:
        'There are issues or controls being sent! These issues or controls will be lost if you log out now.',
      ok: 'View list',
      cancel: 'Log out'
    },
    at: 'at',
    optional: 'optional',
    archive: 'Archive',
    wrote: 'wrote',
    reload: 'Reload'
  },
  failedRequest: {
    title: 'Report a problem',
    information:
      'An email containing debugging information will be sent to the technical team'
  },
  sync: {
    elements: 'elements',
    send: 'sending',
    retrySend: 'Relaunching the shipment',
    finish: 'All tasks have been synchronized',
    exitPage: 'you can leave the page',
    sendIssueError: "Can't send the alerts or checks after several attempts?",
    contactDevelopers: 'Report the problem to the developers by clicking here',
    sendingTalk: 'Sending talks',
    sendingClose: 'In the process of closing',
    elementPending: 'items waiting to be sent',
    elementToSend: 'elements {taskStatus} sending',
    pending: 'pending',
    waiting: 'waiting',
    show: 'Show',
    sendingCode: 'Updating code',
    ongoingTracking: 'Processing...'
  },
  login: {
    connectWithMicrosoft: 'Sign in using Microsoft',
    description: 'Please enter your credentials',
    password: 'Password',
    email: 'Email',
    logIn: 'Log in',
    loginFailed: 'The email or password is incorrect.',
    connectErrors: 'Please enter your credentials',
    forgottenPassword: 'Forgot password',
    tapEmail: 'Please enter your email',
    passwordUpdated: 'Your password was updated',
    pageExpired: 'The link you visited has expired',
    fillPassword: 'Please enter a new password',
    errorPasswordEmpty: 'Please enter your new password',
    fillWithSamePassword: 'Please re-enter password',
    errorSamePasswordValidation: 'The passwords do not match',
    newPassword: 'New password',
    newPasswordConfirmation: 'Please enter your new password twice',
    goBack: 'Back',
    img: 'image',
    mailSent: 'email in a few minutes',
    mailNotSent: 'Your email address is not in our database',
    or: 'Or',
    errorValidationEmail: 'Please enter a valid e-mail address',
    errorValidationPassword: 'Please enter your password',
    password: 'Password',
    confirmPassword: 'Confirm password',
    accountMigratedToV2:
      'Connection not possible: this version of the application has been disabled following the update to SoWell +',
    resetPasswordTitle: 'Resetting your password',
    resetPasswordSubtitle: 'Please set up a new password',
    passwordPlaceholder: 'Minimum 8 characters',
    confirmPasswordPlaceholder: 'Repeat the password',
    passwordRequirementMinLength: '8 characters minimum',
    passwordRequirementUppercase: '1 uppercase letter',
    passwordRequirementLowercase: '1 lowercase letter',
    passwordRequirementDigit: '1 digit',
    passwordRequirementLetter: '1 letter',
    passwordRequirementSpecialChar: '1 special character',
    saveNewPassword: 'Save my new password',
    passwordInvalidFormat:
      'The password you entered does not meet the required format. Please check the criteria above.',
    passwordSequenceError:
      'Password must not contain a simple sequence of 4+ characters (e.g. 1234, abcd, azerty, qwerty).',
    passwordSaved: 'Password saved!',
    passwordSavedSubtitle: 'You can now access all of your SoWell services.',
    connectMe: 'Log in',
    serverError: 'Technical error, please contact your administrator',
    // Magiclink flow (first login / forgotten password)
    firstConnectionQuestion: 'Is this your first login?',
    activateAccount: 'Activate my account',
    firstConnectionTitle: 'Login',
    firstConnectionDescription:
      'Enter your work email address to receive the setup instructions.',
    forgotPasswordTitle: 'Forgotten password',
    forgotPasswordDescription:
      'Enter your work email address to receive the reset instructions.',
    emailPlaceholder: "example{'@'}gmail.com",
    continueButton: 'Continue',
    channelTitle: 'Delivery channel',
    channelSubtitle: 'Choose how you want to receive your secure login link.',
    channelEmailLabel: 'By email',
    channelSmsLabel: 'By SMS',
    channelSmsDescription: 'By SMS',
    channelExpiryWarning:
      'The link will expire in 30 minutes to keep your account secure.',
    sendMagicLink: 'Send the link',
    magicLinkSentTitle: 'Link sent!',
    magicLinkSentDescription:
      'The link has been sent. Click on it to set up your password.',
    magicLinkCheckInboxMessage:
      'Check your inbox and click the link to access your account.',
    magicLinkCheckSmsMessage:
      'Check your text messages and click the link to access your account.',
    openMailbox: 'Open my mailbox',
    resendMagicLink: 'Resend the link',
    resendMagicLinkCountdown: 'Resend the link ({seconds}s)',
    magicLinkWarning:
      "If you don't see the email within a few minutes, check your spam folder.",
    backToFirstLogin: 'Back to first login',
    magicLinkForbiddenTitle: 'Reset unavailable',
    magicLinkForbiddenMessage:
      'Your account uses Microsoft sign-in. Your password is managed by Microsoft. To change it, go to your Microsoft account or contact your administrator.',
    setPasswordTitle: 'Set up your password',
    setPasswordDescription:
      'To access your account, you need to set your default password.',
    magicLinkPasswordChangedSubtitle:
      'Your account is now secure. You can access all of your SoWell services.',
    errorMagicLinkAccountNotFound:
      'No matching account, or an error occurred',
    errorMagicLinkExpired:
      'This link has expired or has already been used. Please start over.',
    errorUnprocessableRequest:
      'Your request could not be processed. Please try again or contact support.',
    // The V1 API returns English business messages: they are never displayed,
    // this is the fallback when the error code is not recognised.
    errorMagicLinkGeneric:
      'Something went wrong. Please try again or contact support.'
  },
  navigation: {
    issue: 'Reports',
    toCreateIssue: 'Report',
    toCreateReport: 'Audit',
    history: 'History',
    audits: 'Audits',
    archivedReports: 'Archived reports'
  },
  notification: {
    title: 'Notification',
    shortTitle: 'Notif',
    issue: `Status for request # {issue} has been updated`,
    default: "SoWell's information",
    appUpdate: 'An update is available, it will be installed automatically',
    appUpdateError: 'An update is available, but cannot be installed',
    appUpdateWarning: 'An update has been installed, SoWell will restart ...',
    permissiondenied: 'Local notifications have been disabled',
    talk: {
      title: 'New talk',
      message: `The request #{issue} has a new talk`,
      ok: 'See',
      cancel: 'Later'
    },
    issueCreated: {
      title: 'New issue',
      message: 'The request #{issue} has just been added to your scope',
      ok: 'See',
      cancel: 'Later'
    },
    categories: {
      alertError: {
        title: 'Sending error',
        message: 'Due to a network issue, your alert was not sent.'
      },
      alertWithoutPosition: {
        title: 'Alert sent without location',
        message: 'Your location could not be determined. Please specify where you are.',
        label: 'Where are you?'
      },
      initAlertDetails: {
        cancel: 'Cancel'
      }
    },
    scheduleNotification: {
      title: 'Some items are waiting to be sent.',
      body: 'Please open the SoWell application in a location with a good internet connection.'
    }
  },
  createIssue: {
    private: 'I will take care of it',
    requestTenant: 'Tenant request',
    request: 'Request',
    tenant: 'Tenant',
    priorityLow: 'Low',
    priorityNormal: 'Normal',
    priorityhigh: 'High',
    rgpd: 'GDPR Info',
    rgpdInfo: 'GDPR information',
    rgpdInfoDetails: {
      personalData: 'In accordance with the regulations on privacy policy',
      accessComment: 'Tenants can access the comments on simple demand.',
      dpo: 'Reminder that the information collected must be objective, adequate, relevant and not excessive with regard to the purpose pursued. To find out more about the use of free comment areas, contact your DPO'
    },
    noSpotOnselectedPlace:
      'No address available for the category and accomodation selected',
    openGallery: 'Open gallery',
    takePicture: 'Take a picture',
    addPicture: 'Add a photo',
    agencyEmpty: 'No agency is selected',
    residenceEmpty:
      'No residence exists on this agency, please contact your technical service',
    placeEmpty:
      'No address exists on this residence, please contact your technical service',
    spotEmpty:
      'No location exists on this address, please contact your technical service',
    sendIssueError: 'An error occurred, please try again later'
  },
  issueDetails: {
    sendMessageTo: 'Send message to',
    detailsOfIssue: 'Reports',
    details: 'Details',
    importance: 'Priority',
    reportAndCheckpointInfo: 'Audit',
    residence: 'Building',
    place: 'Type',
    author: 'Author',
    message: 'Details',
    spot: 'Location',
    sendingTalk: 'Submission in progress',
    createdAt: 'Creation date',
    me: 'Me',
    type: 'Type',
    send: 'Send',
    chat: 'Chat',
    on: 'On',
    by: 'by',
    at: 'at',
    issueDate: 'Date of report',
    fileDownloadSucced: 'File downloaded successfully',
    fileDownloadFailed: 'Unable to download file',
    images: 'Images',
    forwardIssuesMessage: 'Send to ERP',
    externalIssuesUrl: 'Link to the report',
    forwardIssuesSuccess: 'New report submitted successfully',
    forwardIssuesFailed: 'New report submission failed, an error occured',
    reason: 'Reason',
    isPrivate: 'I will take care of it',
    sending: 'Report submission N°',
    close: 'Close',
    closePermissionError:
      'You do not have sufficient rights to close this report',
    closeError: 'An error occured while closing the report',
    codePermissionError: 'You do not have sufficient rights to update issue code',
    codeError: 'An error occured while updating the issue code',
    duplicateError: 'The report is not closed because it is in process',
    unknownError: 'Administrator',
    sendByEmail: {
      title: 'Send by email',
      recipients: "Recipient's emails",
      body: 'Your message',
      recipientsWrong: 'Email address invalid',
      sendSuccess: 'Email sent',
      sendFailed: 'Error while sending email'
    },
    sendSuccess: 'Successfully reported',
    sendError: 'Report transfer failed, an error occurred',
    noIssueToShow: 'No reports to display at this time',
    specifyIssue: 'Specify the report'
  },
  report: {
    ko: 'Anomaly',
    accuracy: 'Information',
    excludedCheckpoint: 'Audit impossible',
    excludedCheckpointWarning:
      "You just indicated that the element to audit does not exist. This question will be deleted after your manager's validation",
    comment: {
      label: 'Comment (Optional)',
      placeholder: 'Your comment here'
    },
    before_date: 'No later than',
    housing: 'Accomodation',
    sendReportError: 'An error has occurred please try again',
    missingSpotError: 'Please select a location before archiving',
    lockedMessage:
      'This control has already been archived. It will be sent to the server automatically.',
    reloadAuditError: 'An error has occurred please try again',
    reloadAuditMessage: "An error has occurred while loading audits"
  },
  audit: {
    loadingAudit: 'Loading of controls',
    auditFinish: 'No more pending checks,',
    goodJob: 'good job !'
  },
  createReport: {
    unprocessableError:
      'This audit has already been achieved less than 24 hours ago'
  },
  createTalk: {
    error: 'Unable to send your message'
  },
  sendAlert: {
    error: 'Unable to send your request assistance'
  }
}
